module.exports = __webpack_public_path__ + "static/img/index.22cbf66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index.jpg
// module id = OTDE
// module chunks = 0